import React, { useRef, useEffect, useState, useLayoutEffect } from 'react';

import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import moment from 'moment';
import { Card, Empty, Select } from 'antd';

am4core.useTheme(am4themes_animated);

const transformFiledToLabel = (fieldName) => {
    return fieldName.replace('_', ' ')
}

function IdleChart({ data: docs, idleFuelRate, selectedGroup, assetData, standardFuelRate,
    processDataWithGroups,
    deviceData, isShowDeviceData, chartUnit = 'hours', loading, ...props }) {

    const [data, setData] = useState([]);
    const [rateTypeField, setRateTypeField] = useState('idle_time');
    // const [rateTypeFieldReverse, setRateTypeFieldReverse] = useState('kms_consumed');

    const [header, setHeader] = useState('--');
    const [standardRateHour, setStandardRateHour] = useState(0);
    const [standardRateKm, setStandardRateKm] = useState(0);

    // const [deviceBasedData, setDeviceBasedData] = useState(null)


    useEffect(() => {
        // console.log(deviceData, isShowDeviceData);
        if (isShowDeviceData && docs && docs.length && deviceData && deviceData.length) {
            const arr = deviceData.concat(docs);
            const map = new Map();
            arr.forEach(d => {
                if (!map.has(d.date)) {
                    const ix = docs.findIndex(i => i.date === d.date)
                    const ixd = deviceData.findIndex(i => i.date === d.date)
                    map.set(d.date, {
                        date: d.date,
                        hours_consumed: ix >= 0 ? docs[ix]['hours_consumed'] : 0,
                        kms_consumed: ix >= 0 ? docs[ix]['kms_consumed'] : 0,
                        distance_travelled: ixd >= 0 ? deviceData[ixd]['distance_travelled'] : 0,
                        moving_time: ixd >= 0 ? (Number(deviceData[ixd].moving_time_min || '0') / 60).toFixed(2) : 0,
                        idle_time: ixd >= 0 ? (Number(deviceData[ixd].idle_time_min || '0') / 60).toFixed(2) : 0,
                    });
                }
            })

            const newDocs = Array.from(map.values());
            // console.log(selectedGroup, newDocs);
            const group = processDataWithGroups(newDocs, selectedGroup)
            // console.log(group);
            setData(group)

            // setData(data)
        } else {
            // console.log(selectedGroup);
            const group = processDataWithGroups(docs, selectedGroup)
            // console.log(group);
            setData(group)
        }
        // setDeviceBasedData(deviceData)
    }, [deviceData, isShowDeviceData, docs, selectedGroup]);

    useLayoutEffect(() => {
        if (chartUnit === 'hours') {
            setRateTypeField('idle_time')
        } else {
            setRateTypeField('distance_travelled')
        }
    }, [chartUnit]);

    useLayoutEffect(() => {
        if (selectedGroup && assetData) {
            const title = selectedGroup === 'w' ? 'Weekly' : selectedGroup === 'm' ? 'Monthwise' : selectedGroup === 'y' ? 'Yearwise' : 'Daywise';
            setHeader(`${title} Idle time chart for ${assetData.assetCode}`)
        }
    }, [selectedGroup, assetData]);

    useEffect(() => {
        if (standardFuelRate && standardFuelRate.length) {
            const hrRate = standardFuelRate.filter(s => (s.perType && s.perType.name && s.perType.name === 'HOURS'))
            if (hrRate && hrRate[0] && hrRate[0]['fuelQty'])
                setStandardRateHour(hrRate[0]['fuelQty'])
            const kmRate = standardFuelRate.filter(s => (s.perType && s.perType.name && s.perType.name === 'KMS'))
            if (kmRate && kmRate[0] && kmRate[0]['fuelQty'])
                setStandardRateKm(kmRate[0]['fuelQty'])
        }
    }, [standardFuelRate]);

    // useLayoutEffect(() => {
    //     if (assetData) {
    //         setHeader(`Daywise ${chartUnit.toLocaleUpperCase()} Idle time chart for asset ${assetData.assetCode}`)
    //     }
    // }, [assetData, chartUnit])

    // console.log(isShowDeviceData);


    const chart = useRef(null);

    useLayoutEffect(() => {
        if (!loading && data && data.length) {

            let totalConsumptionRate = 0;
            data.forEach(d => {
                totalConsumptionRate += Number(d[rateTypeField])
            })

            let x = am4core.create("idleConsumed", am4charts.XYChart);
            // am4core.addLicense("ch-custom-attribution");

            let title = x.titles.create();
            title.text = header || '';
            title.fontSize = 15;
            title.marginBottom = 18;

            // Export
            x.exporting.menu = new am4core.ExportMenu();
            x.exporting.filePrefix = "idle_time" + new Date().getTime();

            x.paddingRight = 20;

            let dateAxis = x.xAxes.push(new am4charts.CategoryAxis());
            dateAxis.dataFields.category = "date";
            dateAxis.title.text = selectedGroup === 'm' ? 'Month' : selectedGroup === 'w' ? 'Week' : selectedGroup === 'y' ? 'Year' : 'Date Range';


            if (isShowDeviceData) {

                let deviceValueAxis = x.yAxes.push(new am4charts.ValueAxis());
                deviceValueAxis.title.text = chartUnit === 'kms' ? 'Distance Travelled - IOT (KMs)' : 'Time Idle - IOT (Hrs.)'
                deviceValueAxis.renderer.line.strokeOpacity = 1;
                deviceValueAxis.renderer.line.strokeWidth = 2;
                deviceValueAxis.renderer.line.stroke = am4core.color("#3D85C6");
                deviceValueAxis.renderer.labels.template.fill = am4core.color("#3D85C6");

                let deviceLineSeries = x.series.push(new am4charts.LineSeries());
                deviceLineSeries.name = chartUnit === 'kms' ? "Kms (IOT)" : "Hours (IOT)";
                deviceLineSeries.dataFields.valueY = chartUnit === 'kms' ? "distance_travelled" : "idle_time";
                deviceLineSeries.dataFields.categoryX = "date";
                deviceLineSeries.strokeWidth = 2;
                deviceLineSeries.propertyFields.strokeDasharray = "lineDash";
                deviceLineSeries.tooltip.label.textAlign = "middle";
                deviceLineSeries.yAxis = deviceValueAxis;
                deviceLineSeries.stroke = am4core.color("#3D85C6");
                // deviceLineSeries.legendSettings.labelText = `Distance. (Total: ${totaldistance_travelled.toFixed(2)} Kms.)`;

                let deviceBullet = deviceLineSeries.bullets.push(new am4charts.Bullet());
                deviceBullet.fill = am4core.color("#fff"); // tooltips grab fill from parent by default
                deviceBullet.tooltipText = "[#3D85C6 font-size: 11px]{name} in {dateX}:\n[/][#3D85C6 font-size: 15px]{valueY}[/] [#3D85C6]{additional}[/]"
                let deviceCircle = deviceBullet.createChild(am4core.Circle);
                deviceCircle.radius = 2;
                deviceCircle.fill = am4core.color("#fff");
                deviceCircle.strokeWidth = 1;

                x.legend = new am4charts.Legend();

                // Add cursor
                x.cursor = new am4charts.XYCursor();
                x.cursor.fullWidthLineX = true;
                x.cursor.xAxis = dateAxis;
                x.cursor.lineX.strokeOpacity = 0;
                x.cursor.lineX.fill = am4core.color("#000");
                x.cursor.lineX.fillOpacity = 0.1;
            }

            x.data = data;

            chart.current = x;

            return () => {
                if (x)
                    x.dispose();
            };
        }
    }, [data, header, rateTypeField, isShowDeviceData]);

    useLayoutEffect(() => {
        if (chart && chart.current)
            chart.current.paddingRight = props.paddingRight;
    }, [props.paddingRight]);

    return <Card>{loading ? (
        <div style={{ width: "100%", height: "500px", display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            Loading ...
        </div>
    ) : data && data.length ? (
        <div id="idleConsumed" style={{ width: "100%", height: "500px" }} />
    ) : (
        <div style={{ width: "100%", height: "500px", display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Empty />
        </div>
    )}</Card>
}

export default IdleChart;